<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto">
      <!--      <CIcon name="logo" height="48" alt="Logo"/>-->
      병해충 영상진단
    </CHeaderBrand>
    <CHeaderNav class="mr-4">
      <span class="mr-2 d-md-down-none">{{ viewItem.date }}</span>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import core from "@/core";
import store from "@/store";

export default {
  name: "TheHeader",
  components: {
  },
  data() {
    return {
      app: store.state.app,
      viewItem: {
        date: null,
      },
    };
  },
  created() {
    const viewItem = this.viewItem;
    setInterval(() => {
      viewItem.date = core.date
        .instance()
        .format("YYYY년 MM월 DD일(ddd) a h:mm:ss");
    }, 300);
  },
};
</script>
